const CorporateFareIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M20,12H16.386l.54-4.334A3,3,0,0,0,14,4.013H11.623L11.883,2H17V.013H10.118l-.515,4H3A2.986,2.986,0,0,0,.665,5.134,2.93,2.93,0,0,0,.059,7.569L2.121,24.013,20,24a4,4,0,0,0,4-4V16A4,4,0,0,0,20,12Zm2,4v1H10V16a2,2,0,0,1,2-2h8A2,2,0,0,1,22,16ZM14,6.013a.992.992,0,0,1,.78.374,1.069,1.069,0,0,1,.18.937L14.873,8H11.108l.257-1.987ZM2.224,6.387A1,1,0,0,1,3,6.013H9.346L9.09,8H2.124l-.1-.771A.993.993,0,0,1,2.224,6.387ZM2.376,10H14.623l-.251,2H12a4,4,0,0,0-4,4v4a3.987,3.987,0,0,0,.544,2.013H3.885ZM20,22H12a2,2,0,0,1-2-2V19h4l3,2,3-2h2v1A2,2,0,0,1,20,22Z" />
  </svg>
);

export default CorporateFareIcon;